<template lang="pug">
  .course-points-shop-preview
    .course-points-shop-preview__header
      p.course-points-shop-preview__header-text
        | Ты окончил курс {{courseTitle}}!
    .course-points-shop-preview__content
      p.course-points-shop-preview__title
        | Дорогой участник!
      p.course-points-shop-preview__subtitle
        | Ты отлично работал и учился на протяжении 6 недель
        | и теперь можешь наградить себя, выбрав подарок на заработанные баллы.
      GiftIcon.course-points-shop-preview__icon.-gift-
      p.course-points-shop-preview__text
        | Набрано {{points}} {{getNoun(points, 'балл', 'балла', 'баллов')}}
      p.course-points-shop-preview__subtext
        | Ты отлично постарался!
      UiButton.course-points-shop-preview__button(
        :to="`/courses/course/${$route.params.courseId}/points_shop/shop`"
      )
        | Перейти к бонусам
        Icon.course-points-shop-preview__button-icon(icon="ui-arrow-right")

</template>

<script>
import { mapState } from 'vuex';
import GiftIcon from './icon/Gift';

export default {
  components: { GiftIcon },
  props: ['points', 'balance'],
  computed: {
    ...mapState('lms', {
      courseTitle: s => s.data.headerTitle
    })
  },
  methods: {
    getNoun(number, one, two, five) {
      let n = Math.abs(number);
      n %= 100;
      if (n >= 5 && n <= 20) {
        return five;
      }
      n %= 10;
      if (n === 1) {
        return one;
      }
      if (n >= 2 && n <= 4) {
        return two;
      }
      return five;
    }
  }
};
</script>
